export default function (response) {
  if (response.headers.get('token')) {
    localStorage.setItem('token', response.headers.get('token'))
  }

  return response
}
